import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyBoa2MLbHE5rPm3i2gnUPiBeS_IfysNkHo",
    authDomain: "fx-rand-widget.firebaseapp.com",
    databaseURL: "https://fx-rand-widget-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "fx-rand-widget",
    storageBucket: "fx-rand-widget.appspot.com",
    messagingSenderId: "803069581617",
    appId: "1:803069581617:web:e7df6845f1115ec036b810"
};
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
} else {
    firebase.app();
}

const defaultMaskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 0, // how many digits allowed after the decimal
    integerLimit: 8, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
}
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exchangeRate: 0,
            fxExchangeRate: 0,
            baseCurrency: 'GBP',
            baseCurrencyImage: '/gbp.png',
            currencyName: 'GBP',
            randValueSell: 750000,
            fxRandRate: 0,
            fxRandForeignCurrency: 0,
            traditionalRate: 0,
            traditionalForeignCurrency: 0,
            currencySavings: 0,
            totalRandSavings: 0,
            zarValueRequired : false,
            currencyRequired: false
        }
        this.onChange = this.onChange.bind(this)
    }
    
    componentDidMount() {
        this.updateExchangeRates(this.state.baseCurrency);
    }
    
    updateExchangeRates(baseCurrency) {
        fetch(`https://free.currconv.com/api/v7/convert?apiKey=213d0f46b235506c3341&q=${baseCurrency}_ZAR`)
            .then(response => response.json())
            .then(data => {
                //{"query":{"count":1},"results":{"GBP_ZAR":{"id":"GBP_ZAR","val":19.752704,"to":"ZAR","fr":"GBP"}}}
                let exchangeRate, fxExchangeRate;
                switch (baseCurrency) {
                    case 'AUD':
                        exchangeRate = data.results.AUD_ZAR.val;
                        fxExchangeRate = data.results.AUD_ZAR.val + 0.02;
                        firebase.database().ref(`AUD_ZAR`).update({
                            ...data.results.AUD_ZAR.val
                        })
                            .catch((error) => console.log(error))
                        break
                    case 'CAD':
                        exchangeRate = data.results.CAD_ZAR.val;
                        fxExchangeRate = data.results.CAD_ZAR.val + 0.02;
                        firebase.database().ref(`CAD_ZAR`).update({
                            ...data.results.CAD_ZAR.val
                        })
                            .catch((error) => console.log(error))
                        break
                    case 'EUR':
                        exchangeRate = data.results.EUR_ZAR.val;
                        fxExchangeRate = data.results.EUR_ZAR.val + 0.02;
                        firebase.database().ref(`EUR_ZAR`).update({
                            ...data.results.EUR_ZAR.val
                        })
                            .catch((error) => console.log(error))
                        break
                    case 'GBP':
                        exchangeRate = data.results.GBP_ZAR.val;
                        fxExchangeRate = data.results.GBP_ZAR.val + 0.02;
                        firebase.database().ref(`GBP_ZAR`).update({
                            ...data.results.GBP_ZAR.val
                        })
                            .catch((error) => console.log(error))
                        break
                    case 'NZD':
                        exchangeRate = data.results.NZD_ZAR.val;
                        fxExchangeRate = data.results.NZD_ZAR.val + 0.02;
                        firebase.database().ref(`NZD_ZAR`).update({
                            ...data.results.NZD_ZAR.val
                        })
                            .catch((error) => console.log(error))
                        break
                    case 'USD':
                        exchangeRate = data.results.USD_ZAR.val;
                        fxExchangeRate = data.results.USD_ZAR.val + 0.02;
                        firebase.database().ref(`USD_ZAR`).update({
                            ...data.results.USD_ZAR.val
                        })
                            .catch((error) => console.log(error))
                        break
                    
                    default:
                        break;
                }
                
                this.setState({
                    exchangeRate: exchangeRate,
                    fxExchangeRate: fxExchangeRate
                })
                this.calculateExchangeRateSavings(this.state.randValueSell);
            })
            .catch((error) => {
                console.log(error);
            })
    }
    
    calculateExchangeRateSavings(value) {
    //`IFS( QA 1. Slide to set the Rand amount to sell <= 250000, ( QA 1. Slide to set the Rand amount to sell -2000) / QB Foreign currency , QA 1. Slide to set the Rand amount to sell <= 1000000, ( QA 1. Slide to set the Rand amount to sell -2500) / QB Foreign currency , QA 1. Slide to set the Rand amount to sell <= 2500000, ( QA 1. Slide to set the Rand amount to sell -4500) / QB Foreign currency , QA 1. Slide to set the Rand amount to sell <= 5000000, ( QA 1. Slide to set the Rand amount to sell -5500) / QB Foreign currency , QA 1. Slide to set the Rand amount to sell <= 7500000, ( QA 1. Slide to set the Rand amount to sell -6500) / QB Foreign currency , QA 1. Slide to set the Rand amount to sell <= 10000000, ( QA 1. Slide to set the Rand amount to sell -7500) / QB Foreign currency )`
        let fxRandForeignCurrency, traditionalForeignCurrency;
        switch (true) {
            case (value >= 150000 && value < 250000):
                fxRandForeignCurrency = ((value - 2000) / this.state.fxExchangeRate);
                traditionalForeignCurrency = (value / (this.state.exchangeRate * 1.015));
                break;
                
            case (value >= 250000 && value <= 1000000):
                fxRandForeignCurrency = ((value - 2500) / this.state.fxExchangeRate);
                traditionalForeignCurrency = (value / (this.state.exchangeRate * 1.015));
                break;
                
            case (value > 1000000 && value <= 2500000):
                fxRandForeignCurrency = ((value - 4500) / this.state.fxExchangeRate);
                traditionalForeignCurrency = (value / (this.state.exchangeRate * 1.013));
                break;
                
            case (value > 2500000 && value <= 5000000):
                fxRandForeignCurrency = ((value - 5500) / this.state.fxExchangeRate);
                traditionalForeignCurrency = (value / (this.state.exchangeRate * 1.011));
                break;
                
            case (value > 5000000 && value <= 7500000):
                fxRandForeignCurrency = ((value - 6500) / this.state.fxExchangeRate);
                traditionalForeignCurrency = (value / (this.state.exchangeRate * 1.0095));
                break;
                
            case (value > 7500000 && value <= 10000000):
                fxRandForeignCurrency = ((value - 7500) / this.state.fxExchangeRate);
                traditionalForeignCurrency = (value / (this.state.exchangeRate * 1.009));
                break;
                
            default:
                fxRandForeignCurrency = 0;
                traditionalForeignCurrency = 0;
                break;
        }
        
        this.setState({
            fxRandForeignCurrency: fxRandForeignCurrency.toFixed(2),
            traditionalForeignCurrency: traditionalForeignCurrency.toFixed(2),
            fxRandRate: (value / fxRandForeignCurrency).toFixed(2),
            traditionalRate: (value / traditionalForeignCurrency).toFixed(2),
            currencySavings: (fxRandForeignCurrency - traditionalForeignCurrency).toFixed(2),
            totalRandSavings: ((fxRandForeignCurrency - traditionalForeignCurrency) * this.state.exchangeRate).toFixed(2)
        })
    }
    
    onChange = (e) => {
        let val = parseFloat(e.target.value.replace(/,/g, ''))
        const re = /^[0-9\b]+$/;
        if (re.test(parseInt(val))) {
            if (val >= 150000 && val <= 10000000) {
                this.setState({
                    zarValueRequired: false,
                    randValueSell: parseInt(val),
                })
            } else {
                this.setState({
                    zarValueRequired: true,
                    randValueSell:parseInt(val),
                })
            }
            this.calculateExchangeRateSavings(parseInt(val));
        }
    }
    
    updateBaseCurrency = (currency) => {
        if (currency.length === 3) {
            let currencyName;
            switch (currency) {
                case 'GBP':
                    currencyName = 'GBP'
                    break;
                case 'EUR':
                    currencyName = 'EUR'
                    break;
                case 'USD':
                    currencyName = 'USD'
                    break;
                case 'AUD':
                    currencyName = 'AUD'
                    break;
                case 'NZD':
                    currencyName = 'NZD'
                    break;
                case 'CAD':
                    currencyName = 'CAD'
                    break;
                default:
                    currencyName = 'GBP'
                    break;
            }

            this.setState({
                baseCurrency: currency,
                baseCurrencyImage: `/${currency}.png`,
                currencyRequired: false,
                currencyName: currencyName
            })
            this.updateExchangeRates(currency);
        } else {
            this.setState({
                currencyRequired: true
            })
        }
    }
    
    render() {
        const currencyMask = createNumberMask(defaultMaskOptions)
        
        return (
            <div className="App" style={{paddingTop: '5px', padding: '2px', backgroundColor: '#0F4DBC', maxWidth: '665px', height: '508px'}}>
                <div className="card">
                    <div className="card-body">

                        <div className="row" style={{paddingLeft: "10px", paddingTop: '5px'}}>
                            <div className="col-md-8 col-md-8 col-sm-8 col-xs-6" style={{ height: '40px'}}>
                                <p style={{fontSize: '23px'}}>I want to convert</p>
                            </div>
                            <div className="col-md-4 col-md-4 col-sm-4 col-xs-12">
                                <div className="input-group mb-3">
                                    <span className="input-group-text" style={{fontSize: '25px'}}><img src="/zar.png" alt="ZAR" /></span>
                                    <MaskedInput id="zarValue" className="form-control"
                                                 mask={currencyMask}
                                                 style={{direction: 'rtl'}}
                                                 onChange={this.onChange}
                                                 value={this.state.randValueSell}
                                                 name='zarValue'
                                                 required
                                    />
                                </div>
                                {(this.state.zarValueRequired === true) &&
                                <div className="row">
                                    <div style={{color: 'red', fontSize: '10px'}}>
                                        Please enter a ZAR amount between 150,000 and 10,000,000.
                                    </div>
                                </div>
                                }
                            </div>
                        </div>

                        <div className="row" style={{paddingLeft: "10px"}}>
                            <div className="col-md-8 col-md-8 col-sm-8 col-xs-6" style={{ height: '40px'}}>
                                <p style={{fontSize: '23px'}}>To this foreign currency</p>
                            </div>
                            <div className="col-md-4 col-md-4 col-sm-4 col-xs-12">
                                <div className="input-group mb-3">
                                    <div className="dropdown" style={{width: '100%'}}>

                                        <button className="btn btn-sm" type="button"
                                                id="dropdownMenuButton2" data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                style={{width: '100%', alignContent: 'left', padding: '0', cursor: 'pointer'}}>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text"><img src={this.state.baseCurrencyImage.toLowerCase()} alt="baseCurrencyImage" /></span>
                                                <input type="text" id="currencySelectorList" className="form-control" style={{cursor: 'pointer', direction: 'rtl'}}
                                                       placeholder=""
                                                       onChange={this.onChange}
                                                       value={this.state.currencyName}
                                                       name='currencySelectorList'
                                                       required
                                                       readOnly={true}
                                                />
                                            </div>
                                        </button>
                                        <ul className="dropdown-menu" style={{cursor: 'pointer'}}
                                            aria-labelledby="dropdownMenuButton2">
                                            <li>
                                                <span className={`dropdown-item ${(this.state.baseCurrencyImage === 'GBP') ? 'active' : ''}`} onClick={() => this.updateBaseCurrency('GBP')}>
                                                    <span style={{paddingRight: '8px'}}>
                                                        <img src="/gbp.png" alt="GBP" />
                                                    </span>
                                                    <strong>GBP</strong>
                                                </span>
                                            </li>
                                            <li>
                                                <span className={`dropdown-item ${(this.state.baseCurrencyImage === 'EUR') ? 'active' : ''}`} onClick={() => this.updateBaseCurrency('EUR')}>
                                                    <span style={{paddingRight: '8px'}}>
                                                        <img src="/eur.png" alt="EUR" />
                                                    </span>
                                                    <strong>EUR</strong>
                                                </span>
                                            </li>
                                            <li>
                                                <span className={`dropdown-item ${(this.state.baseCurrencyImage === 'USD') ? 'active' : ''}`} onClick={() => this.updateBaseCurrency('USD')}>
                                                    <span style={{paddingRight: '8px'}}>
                                                        <img src="/usd.png" alt="USD" />
                                                    </span>
                                                    <strong>USD</strong>
                                                </span>
                                            </li>
                                            <li>
                                                <span className={`dropdown-item ${(this.state.baseCurrencyImage === 'AUD') ? 'active' : ''}`} onClick={() => this.updateBaseCurrency('AUD')}>
                                                    <span style={{paddingRight: '8px'}}>
                                                        <img src="/aud.png" alt="AUD" />
                                                    </span>
                                                    <strong>AUD</strong>
                                                </span>
                                            </li>
                                            <li>
                                                <span className={`dropdown-item ${(this.state.baseCurrencyImage === 'NZD') ? 'active' : ''}`} onClick={() => this.updateBaseCurrency('NZD')}>
                                                    <span style={{paddingRight: '8px'}}>
                                                        <img src="/nzd.png" alt="NZD" />
                                                    </span>
                                                    <strong>NZD</strong>
                                                </span>
                                            </li>
                                            <li>
                                                <span className={`dropdown-item ${(this.state.baseCurrencyImage === 'CAD') ? 'active' : ''}`} onClick={() => this.updateBaseCurrency('CAD')}>
                                                    <span style={{paddingRight: '8px'}}>
                                                        <img src="/cad.png" alt="CAD" />
                                                    </span>
                                                    <strong>CAD</strong>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row" style={{paddingLeft: "10px", paddingTop: '0px'}}>
                            <div className="col-md-8 col-md-8 col-sm-8 col-xs-6" style={{ height: '40px'}}>
                                <p style={{fontSize: '23px'}}>What you get in foreign currency:</p>
                            </div>
                        </div>

                        <div className="row" style={{paddingLeft: "10px", paddingTop: '5px'}}>
                            <div className="col-md-8 col-md-8 col-sm-8 col-xs-6" style={{ height: '40px', backgroundColor: "#000000", color: "#e3e3e3"}}>
                                <p style={{fontSize: '23px'}}><span style={{color: '#0F4DBC'}}>FX</span> Rand
                                    <span style={{fontSize: '15px', float: 'right', paddingTop: '8px', color: 'rgba(204,204,204,0.61)'}}>@ {this.state.fxRandRate}</span>
                                </p>
                            </div>
                            <div className="col-md-4 col-md-4 col-sm-4 col-xs-12">
                                <div className="input-group mb-3">
                                    <span className="input-group-text"><img src={this.state.baseCurrencyImage.toLowerCase()} alt="ZAR" /></span>
                                    
                                    <input type="text" className="form-control"
                                           style={{direction: 'rtl'}}
                                           placeholder=""
                                           value={this.state.fxRandForeignCurrency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                           name='fxRandValue'
                                           readOnly={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row" style={{paddingLeft: "10px", paddingTop: '10px'}}>
                            <div className="col-md-8 col-md-8 col-sm-8 col-xs-6" style={{ height: '40px', backgroundColor: "#000000", color: "#e3e3e3"}}>
                                <p style={{fontSize: '23px'}}>Standard forex provider
                                    <span style={{fontSize: '15px', float: 'right', paddingTop: '8px', color: 'rgba(204,204,204,0.61)'}}>@ {this.state.traditionalRate}</span>
                                </p>
                            </div>
                            <div className="col-md-4 col-md-4 col-sm-4 col-xs-12">
                                <div className="input-group mb-3">
                                    <span className="input-group-text"><img src={this.state.baseCurrencyImage.toLowerCase()} alt="ZAR" /></span>
                                    <input type="text" className="form-control"
                                           style={{direction: 'rtl'}}
                                           placeholder=""
                                           value={this.state.traditionalForeignCurrency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                           name='otherValue'
                                           readOnly={true}
                                    />
                                </div>
                            </div>
                        </div>
    
                        <div className="row" style={{paddingLeft: "10px", paddingTop: '10px'}}>
                            <div className="col-md-8 col-md-8 col-sm-8 col-xs-6" style={{ height: '40px', backgroundColor: "#000000", color: "#e3e3e3"}}>
                                <p style={{fontSize: '23px'}}>Extra value with <span style={{color: '#0F4DBC'}}>FX</span> Rand</p>
                            </div>
                            <div className="col-md-4 col-md-4 col-sm-4 col-xs-12">
                                <div className="input-group mb-3">
                                    <span className="input-group-text"><img src={this.state.baseCurrencyImage.toLowerCase()} alt="ZAR" /></span>
                                    <input type="text" className="form-control"
                                           style={{direction: 'rtl'}}
                                           placeholder=""
                                           value={this.state.currencySavings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                           name='savingValue'
                                           readOnly={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{paddingLeft: "10px", paddingTop: '25px'}}>
                            <hr color="grey" />
                        </div>
                        <div className="row" style={{paddingLeft: "10px", paddingTop: '10px'}}>
                            <div className="col-md-8 col-md-8 col-sm-8 col-xs-6" style={{ height: '40px', backgroundColor: "#000000", color: "#e3e3e3"}}>
                                <p style={{fontSize: '23px'}}>Extra value Rand equivalent</p>
                            </div>
                            <div className="col-md-4 col-md-4 col-sm-4 col-xs-12">
                                <div className="input-group mb-3">
                                    <span className="input-group-text"><img src="/zar.png" alt="ZAR" /></span>
                                    <input type="text" className="form-control"
                                           style={{direction: 'rtl'}}
                                           placeholder=""
                                           value={this.state.totalRandSavings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                           name='savingValue'
                                           readOnly={true}
                                    />
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        );
    }
}



export default App;
